module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"zh-Hans":{"document-title":"购买/续费方式"},"zh-Hant":{}}')
  delete Component.options._Ctor
}
